import { render } from "./SpontaneousSpeakingTest.vue?vue&type=template&id=07f272ff&scoped=true"
import script from "./SpontaneousSpeakingTest.vue?vue&type=script&lang=js"
export * from "./SpontaneousSpeakingTest.vue?vue&type=script&lang=js"

import "./SpontaneousSpeakingTest.vue?vue&type=style&index=0&id=07f272ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f272ff"]])

export default __exports__